import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "createTagModal",
  ref: "modalEl"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Create new tag"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn-close",
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tag name", -1)
const _hoisted_9 = { class: "col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Product", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-0" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mt-3" }, "Choose tag color:", -1)
const _hoisted_15 = { class: "form-label mt-3" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mt-3" }, "From existing tag:", -1)
const _hoisted_18 = { class: "modal-footer" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary",
  type: "button",
  "data-bs-dismiss": "modal"
}, "Cancel", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.name) = $event))
              }, null, 512), [
                [_vModelText, $setup.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.product) = $event))
              }, [
                _hoisted_11,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.products?.products, (prod) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: prod.id
                  }, _toDisplayString(prod.prettyName), 9, _hoisted_12))
                }), 256))
              ], 512), [
                [_vModelSelect, $setup.product]
              ])
            ])
          ]),
          _hoisted_13,
          _hoisted_14,
          _withDirectives(_createElementVNode("input", {
            class: "d-block",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.color) = $event)),
            type: "color"
          }, null, 512), [
            [_vModelText, $setup.color]
          ]),
          _createElementVNode("label", _hoisted_15, [
            _createTextVNode("From random colors"),
            _createElementVNode("a", {
              href: "#",
              onClick: _withModifiers($setup.generateRandom, ["prevent"])
            }, " (Generate)")
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.randomColors, (clr) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "btn me-1 text-white",
                style: _normalizeStyle({backgroundColor: clr}),
                onClick: $event => ($setup.color = clr)
              }, _toDisplayString(clr), 13, _hoisted_16))
            }), 256))
          ]),
          _hoisted_17,
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.allTags, (tag) => {
              return (_openBlock(), _createBlock($setup["Tag"], {
                class: "pointer me-1",
                tag: tag,
                onClick: $event => ($setup.color = tag.color)
              }, null, 8, ["tag", "onClick"]))
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[3] || (_cache[3] = $event => ($setup.submit(false)))
          }, "Create"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[4] || (_cache[4] = $event => ($setup.submit(true)))
          }, "Create and add")
        ])
      ])
    ])
  ], 512))
}